var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import Button from '../atoms/BaseButton';
import TextField from '../atoms/TextField';
var Sticky = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: sticky;\n  bottom: 0;\n  background-color: white;\n\n  button {\n    margin-right: 10px;\n  }\n"], ["\n  position: sticky;\n  bottom: 0;\n  background-color: white;\n\n  button {\n    margin-right: 10px;\n  }\n"])));
var StickyCommentForm = function (_a) {
    var _b;
    var disabled = _a.disabled, onSubmit = _a.onSubmit, body = _a.body, onChange = _a.onChange, otherProps = __rest(_a, ["disabled", "onSubmit", "body", "onChange"]);
    var t = useTranslation().t;
    return (React.createElement(Sticky, null,
        React.createElement(Box, { my: 2, textAlign: "center" },
            React.createElement(TextField, { multiline: true, fullWidth: true, rows: 5, value: body, onChange: function (event) { return onChange(event.target.value); }, disabled: disabled, inputProps: (_b = {}, _b['aria-label'] = otherProps['aria-label'], _b) }),
            React.createElement(Box, { my: 1 },
                React.createElement(Typography, { variant: "caption" }, t('pages.roasterOrder.commentHelp'))),
            React.createElement(Box, { my: 1 },
                React.createElement(Typography, { variant: "caption" }, t('pages.roasterOrder.translation'))),
            React.createElement(Button, { onClick: function () {
                    onSubmit(body);
                }, disabled: disabled || !body.trim() }, t('pages.roasterOrder.postComment')))));
};
export default StickyCommentForm;
var templateObject_1;
